import type {
  ProcessedBetEntry,
  ProcessedCompetitor,
  ProcessedEntry,
  ProcessedExoticMultiSelection,
  ProcessedFranchiseCompetitor,
  ProcessedPickemEntry,
  ProcessedPickemSelection,
  ProcessedPlayerCompetitor,
  ProcessedQuaddieSelection,
  ProcessedRacingCompetitor,
  ProcessedSameEventMultiSelection,
  ProcessedSelection,
  ProcessedSingleSelection,
} from "@/hooks/firestore/betting/useEntries";

export function isBetEntry(entry?: ProcessedEntry): entry is ProcessedBetEntry {
  return entry?.entryType === "BET";
}

export function isPickemsEntry(
  entry?: ProcessedEntry,
): entry is ProcessedPickemEntry {
  return entry?.entryType === "PICKEM";
}

export function isPickemsSelection(
  selection: ProcessedSelection | ProcessedPickemSelection,
): selection is ProcessedPickemSelection {
  return "points" in selection;
}

export function isSingleSelection(
  selection: ProcessedSelection,
): selection is ProcessedSingleSelection {
  return selection.type === "SingleOutcome";
}

export function isSameEventMultiSelection(
  selection: ProcessedSelection,
): selection is ProcessedSameEventMultiSelection {
  return selection.type === "SameEventMulti";
}

export function isExoticSelection(
  selection: ProcessedSelection,
): selection is ProcessedExoticMultiSelection {
  return selection.type === "Exotic";
}

export function isQuaddieSelection(
  selection: ProcessedSelection,
): selection is ProcessedQuaddieSelection {
  return selection.type === "Quaddie";
}

export function isRaceCompetitor(
  competitor: ProcessedCompetitor | null,
): competitor is ProcessedRacingCompetitor {
  return !!competitor && !("type" in competitor);
}

export function isFranchiseCompetitor(
  competitor: ProcessedCompetitor | null,
): competitor is ProcessedFranchiseCompetitor {
  return (
    !!competitor && "type" in competitor && competitor.type === "FRANCHISE"
  );
}

export function isPlayerCompetitor(
  competitor: ProcessedCompetitor | null,
): competitor is ProcessedPlayerCompetitor {
  return !!competitor && "type" in competitor && competitor.type === "PLAYER";
}
